module.exports = __webpack_public_path__ + "static/img/Simulence_logo.1705985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Simulence_logo.png
// module id = zA+Q
// module chunks = 1